import { fetchActionWrapper, entityActionWrapper } from 'barnyard/utils';
import * as types from '../constants';


const profileFetches = fetchActionWrapper({
  CREATE_ACTION: types.PROFILE_CREATE,
});

const profileWithMetadata = entityActionWrapper({
  GET_ACTION: types.PROFILE_FETCH
});

const profile = (state = {}, action) => {
  switch (action.type) {
    case types.PROFILE_CREATE.success:
      return action.result;
    case types.PROFILE_FETCH.request:
    case types.PROFILE_FETCH.success:
    case types.PROFILE_FETCH.failure:
      return profileWithMetadata(state, action, action.result);
    default:
      return state;
  }
};

export {
  profile,
  profileFetches
};
